export const OSM = {
    Layer: 'osm.layer',
    Colored: 'osm.colored',
    Opacity: 'osm.opacity',
    FAI: 'osm.fai',
};

export const Region = {
    confirmChange: 'region.confirm-change',
};

export const Route = {
    startHour: 'route.hour',
    startMinute: 'route.minute',
    arrivalTime: 'route.arrival-time',
    plane: 'route.plane',
    climbRate: 'route.climb-rate',
    descentRate: 'route.descent-rate',
    cruisingAltitude: 'route.cruising-altitude',
    cruisingSpeed: 'route.cruising-speed',
    skillLevel: 'route.skill-level',
    hourlyAverage: 'route.hourly-average',
};
